<template>
  <section class="py-5 h-100 d-flex justify-content-center">
    <v-card class="w-75 m-auto border rounded">
      <v-card-text class="p-4">
        <v-row>
          <v-col cols="12" sm="12" lg="6" class="border-right">
            <h2 :class="returnState()">QRate</h2>
            <br />
            <img
              alt="QRate"
              class="logo_img_lg w-100 h-75"
              src="../../assets/two_factor_authentication.png"
              style="max-height: 75% !important"
            />
          </v-col>

          <v-col cols="12" sm="12" lg="6" class="pb-2">
            <div class="w-100 m-auto p-5">
              <h2 class="text-center text-primary-color font-weight-bold">
                {{ $t("loginScreen.twoFactorAuth") }}
              </h2>
              <br />
              <!-- <v-alert
                v-if="alertMsg.status"
                :timeout="alertMsg.timeout"
                :color="alertMsg.color"
                :type="alertMsg.type"
                dismissible
              >
                {{ alertMsg.text }}
              </v-alert> -->

              <form class="mb-4">
                <label class="text-midgray-color">
                  {{ $t("loginScreen.twoFactorAuthLable") }}
                </label>
                <div class="m-auto position-relative" style="max-width: 300px">
                  <v-otp-input
                    length="6"
                    v-model="otpEntered"
                    :disabled="isOTPVerified"
                    @input="$v.otpEntered.$touch()"
                    @blur="$v.otpEntered.$touch()"
                    :error-messages="otpErrors"
                    class="font-weight-bold"
                  ></v-otp-input>

                  <h6 class="text-dark" v-if="timerCount > 0">
                    OTP will expire in the next
                    <span class="font-weight-bold">{{ timerCount }}</span>
                    seconds
                  </h6>

                  <div
                    class="text-center d-flex justify-content-center align-items-baseline"
                    v-if="timerCount === 0"
                  >
                    <span class="text-dark">Didn't receive the OTP?</span>
                    <v-btn
                      depressed
                      class="text-capitalize"
                      color="primary"
                      @click="getOTPCode"
                      text
                      :loading="isOTPLoading"
                      >Resend OTP</v-btn
                    >
                  </div>

                  <v-overlay absolute :value="isOTPVerified">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-overlay>
                </div>

                <v-btn
                  depressed
                  block
                  color="primary"
                  @click="onOTPVerify"
                  class="btn-primary mt-4 text-capitalize"
                >
                  Confirm OTP
                </v-btn>

                <div
                  class="text-dark mt-4 d-flex justify-content-center align-items-baseline"
                >
                  <span>Back to</span>
                  <v-btn
                    depressed
                    class="text-capitalize text-primary-color p-2"
                    color="primary"
                    plain
                    @click="$router.push('/login')"
                  >
                    {{ $t("loginScreen.loginPage") }}?
                  </v-btn>
                </div>
              </form>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import alerts from "@/mixins/alerts";
import userService from "@/services/UserService/userService.js";
export default {
  mixins: [alerts],
  name: "TwoFactorAuth",
  mounted() {
    this.getOTPCode();
  },
  data() {
    return {
      otpEntered: "",
      isOTPVerified: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      // alertMsg: {
      //   status: false,
      //   text: "",
      //   timeout: 2000,
      //   color: "blue-grey",
      //   type: "success",
      // },
      isOTPEnable: false,
      timerCount: 0,
      isOTPLoading: false,
    };
  },
  validations: {
    otpEntered: {
      required,
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        // console.log("isOTPEnable", this.isOTPEnable)
        if (value > 0 && this.isOTPEnable) {
          // Time interval to run every 1 sec.
          setTimeout(() => {
            // stop interval when time out reaches to zero.
            if (this.timerCount === 0) return;
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  computed: {
    otpErrors() {
      const errors = [];
      if (!this.$v.otpEntered.$dirty) return errors;
      !this.$v.otpEntered.required && errors.push("OTP is required");
      return errors;
    },
    ...mapGetters("Authentication", ["user_email"]),
  },
  methods: {
    returnState() {
      return process.env.NODE_ENV === "dev"
        ? "text-white-color primary text-center"
        : "text-primary-color";
    },
    async getOTPCode() {
      // alert('i am hitted')
      const user_email = sessionStorage.getItem("username");
      if (!user_email) return;
      console.log("user_email", user_email);
      this.isOTPLoading = true;
      try {
        const responseData = await userService.getOTP(user_email);
        this.isOTPLoading = false;
        // console.log(`get_otp_2FA responseData: ${JSON.stringify(responseData)}`);
        console.log("responseData", responseData);
        if (responseData && responseData.data.success) {
          this.isOTPEnable = true;
          this.timerCount = 300;
          this.showAlertSuccess(responseData.data.message);
          // this.alertMsg.status = true;
          // this.alertMsg.text = responseData.data.message;
          // this.alertMsg.type = "success";
          // this.alertMsg.color = "green";
        } else {
          this.isOTPEnable = false;
          this.showAlertError(responseData.message);
          // this.alertMsg.status = true;
          // this.alertMsg.text = responseData.message;
          // this.alertMsg.type = "error";
          // this.alertMsg.color = "warning";
        }
      } catch (err) {
        this.isOTPLoading = false;
        this.isOTPEnable = false;
        this.showAlertError(err.message);
        // this.alertMsg.status = true;
        // this.alertMsg.text = err.message;
        // this.alertMsg.type = "error";
        // this.alertMsg.color = "warning";
      }
    },
    async onOTPVerify() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const user_email = sessionStorage.getItem("username");
      if (!user_email) return;
      this.isOTPVerified = true;
      const userDeatils = {
        user_email: user_email,
        otp: this.otpEntered,
        user_type: "USR",
      };
      try {
        const responseData = await userService.verifyOTP(userDeatils);
        console.log("responseData", responseData);
        if (responseData.data.status_code === 200) {
          if (responseData.data.data[0].user_type) {
            sessionStorage.setItem(
              "user_type",
              responseData.data.data[0].user_type
            );
          }
          sessionStorage.setItem(
            "is_evolet_user",
            responseData.data.data[0].is_evolet_user
          );
          sessionStorage.setItem(
            "__ac_mn_tk",
            responseData.data.data[0].access_token
          );
          console.log("access", responseData.data.data[0].access_token);
          sessionStorage.setItem(
            "complete_registration",
            responseData.data.data[0].complete_registration
          );
          sessionStorage.setItem(
            "__re_acc_tk",
            responseData.data.data[0].refresh_token
          );
          const data = JSON.stringify(responseData.data.data[0].send_partner_data);
            sessionStorage.setItem("send_partner_data", data);
          sessionStorage.setItem(
            "__p_info",
            JSON.stringify(responseData.data.data[0].permissions_info)
          );
          this.$store.commit("__ac_mn_tk", responseData.data.data[0].access_token);
          this.$store.commit(
            "complete_registration",
            responseData.data.data[0].complete_registration
          );
          this.isOTPEnable = false;
          this.isOTPVerified = false;
          this.showAlertSuccess(responseData.data.message);
          // this.alertMsg.status = true;
          // this.alertMsg.text = responseData.data.message;
          // this.alertMsg.type = "success";
          // this.alertMsg.color = "green";
          setTimeout(() => this.$router.push({ name: "Home" }), 500);
        } else {
          this.isOTPEnable = true;
          this.isOTPVerified = false;
          this.showAlertError(
            "OTP entered is not a valid. Try to enter the OTP again"
          );
          // this.alertMsg.status = true;
          // this.alertMsg.text =
          //   "OTP entered is not a valid. Try to enter the OTP again";
          // this.alertMsg.type = "error";
          // this.alertMsg.color = "warning";
        }
      } catch (err) {
        console.log("err", err);
        this.isOTPVerified = false;
        this.isOTPEnable = true;
        this.showAlertError("Something Went Wrong");
        // this.alertMsg.status = true;
        // this.alertMsg.text = "Something Went Wrong";
        // this.alertMsg.type = "error";
        // this.alertMsg.color = "warning";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.lead {
  font-weight: 400;
  color: $txt;
}
.logo_img {
  max-height: 50px;
}
.logo_img_lg {
  max-height: 100px;
}
.div-signup {
  color: $txt;
  cursor: pointer;
}
.login {
  height: 100%;
}
.invalid-feedback-email {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 12px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.invalid-feedback-password {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 12px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.language-selection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button#input-type__BV_toggle_ {
  font-size: 10px;
}
.forgot-link {
  margin-top: 26px;
  line-height: 3rem;
}

.shadow_class {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  // width: %;
  background: #f8f9fa;
  border-radius: 7px;
}
</style>
